"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSmartAnimationFrame = exports.requestSmartAnimationFrame = void 0;
var animationFramesCounter = 0;

var getAnimationFrameId = function getAnimationFrameId() {
  return animationFramesCounter++;
};

var smartAnimationFrames = {};

var getCurrentAnimationFrames = function getCurrentAnimationFrames() {
  var currentFrames = smartAnimationFrames;
  smartAnimationFrames = {};
  return Object.keys(currentFrames).map(function (frameId) {
    return currentFrames[frameId];
  });
};

var requestedAnimationFrame = false;

var handleAnimationFrame = function handleAnimationFrame(timestamp) {
  var animationFrames = getCurrentAnimationFrames();
  requestedAnimationFrame = false;
  animationFrames.forEach(function (frame) {
    return frame.readResult = frame.read(timestamp);
  });
  animationFrames.forEach(function (frame) {
    return frame.write(timestamp, frame.readResult);
  });
}; // These two function acts the same as requestAnimationFrame and CancelAnimationFrame.
// The only diffrence is that requestSmartAnimationFrame is provided with a write and read callbacks.
// All the read callbacks are called and than all the write callbacks are called with the read results.
// This way we make sure there isn't a write read situation using unrelated parallel requestAnimationFrame calls.


var requestSmartAnimationFrame = function requestSmartAnimationFrame(write) {
  var read = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var animationFrameId = getAnimationFrameId();
  smartAnimationFrames[animationFrameId] = {
    write: write,
    read: read
  };

  if (!requestedAnimationFrame) {
    requestedAnimationFrame = true;
    requestAnimationFrame(handleAnimationFrame);
  }

  return animationFrameId;
};

exports.requestSmartAnimationFrame = requestSmartAnimationFrame;

var cancelSmartAnimationFrame = function cancelSmartAnimationFrame(animationFrameId) {
  delete smartAnimationFrames[animationFrameId];
};

exports.cancelSmartAnimationFrame = cancelSmartAnimationFrame;